export const GET_ALL_REPORT_DISPLAY = 'GET_ALL_REPORT_DISPLAY'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
